<template>
  <!-- 报告页面 -->
  <div class="pd20">
    <div class="main">
      <!-- list -->
      <div class="list-box">
        <el-table :data="list" show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="100" label="序号"></el-table-column>
          <el-table-column prop="id" label="ID" width="100"></el-table-column>
          <el-table-column label="名称">
            <template slot-scope="scope">
              {{typeToText(scope.row.type)}}
              <span v-if="scope.row.type =='title1' || scope.row.type =='title2' || scope.row.type =='title3'">（{{scope.row.content}}）</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editReporthandle(scope.$index, scope.row)" circle></el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeHandle(scope.$index, scope.row)" circle></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加按钮 -->
      <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus" @click="addReporthandle" circle></el-button>
      <el-button type="primary" class="addBtn previewBtn" size="mini" icon="el-icon-mobile" @click="previewHandle">{{preview_text}}</el-button>
      <el-button type="primary" class="addBtn previewBtn sortBtn" size="mini" icon="el-icon-sort" @click="toReportAllList">排序</el-button>
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
      </el-pagination>
    </div>
    <!--  -->
    <el-dialog :visible.sync="reportDialog">
      <el-form class="form-box" :model="form">
        <el-form-item label="模块" :label-width="formLabelWidth">
          <el-select v-model="form.type" @change="typeChange" placeholder="请选择活动区域">
            <el-option label="一级标题" value="title1">一级标题</el-option>
            <el-option label="二级标题" value="title2">二级标题</el-option>
            <el-option label="三级标题" value="title3">三级标题</el-option>
            <el-option label="动态文字" value="text">动态文字</el-option>
            <el-option label="动态图片" value="image">动态图片</el-option>
            <el-option label="动态图表" value="chart">动态图表</el-option>
            <el-option label="动态海报" value="posters">动态海报</el-option>
            <el-option label="测评说明" value="explain">测评说明</el-option>
            <el-option label="测评结果" value="results">测评结果</el-option>
            <el-option label="转发分享" value="share">转发分享</el-option>
          </el-select>
        </el-form-item>
        <!-- 标题 -->
        <el-form-item v-if="form.type==='title1' || form.type==='title2' || form.type==='title3' || !form.type" label="内容" :label-width="formLabelWidth">
          <el-input v-model="form.content" autocomplete="off"></el-input>
        </el-form-item>
        <!--  -->
        <el-form-item v-if="form.type==='text' ||form.type==='image' ||form.type==='chart' ||form.type==='posters' " label="内容" :label-width="formLabelWidth">
          <el-select v-model="form.content" placeholder="请选择内容">
            <el-option v-for="(item,index) in content_list" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
          </el-select>
        </el-form-item>
        <!-- 测评说明 -->
        <el-form-item v-if="form.type==='explain'" label="内容" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="2" v-model="form.content" autocomplete="off"></el-input>
        </el-form-item>
        <!-- 测评结果 -->
        <el-form-item class="results-select" v-if="form.type==='results'" type="textarea" :rows="2" label="内容" :label-width="formLabelWidth">
          <el-select class="select" @change="resultTypeChange" v-model="form.result_type" placeholder="请选择结果">
            <el-option label="公式" value="0">公式</el-option>
            <el-option label="文字" value="1">文字</el-option>
          </el-select>
          <el-select :disabled="!form.result_type" class="select on" v-model="form.content" placeholder="请选择">
            <el-option v-for="item in dynamic_result_type" :key="item.id" :label="item.name" :value="item.id+''">{{item.name}}</el-option>
          </el-select>
        </el-form-item>
        <!-- 前置 -->
        <el-form-item v-if="form.type==='results' || form.type==='share'" :label="form.type==='results'?'前置':'分享前图片'" :label-width="formLabelWidth">
          <el-input v-if="form.type==='results'" v-model="form.before" autocomplete="off" placeholder="根据测评结果，您的分化水平得分为："></el-input>
          <!-- 转发分享 -->
          <el-upload v-if="form.type==='share'" class="upload-demo" :show-file-list="false" :http-request="beforeUploadImg" :before-upload="beforeAvatarUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <!--  -->
          <el-image v-if="form.type==='share'" class="up-image" :src="form.before">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" :style="{height:basis_src?'':'150px','line-height':basis_src?'':'150px'}" class="image-slot error">
              请上传图片...
            </div>
          </el-image>
        </el-form-item>
        <!-- 后置 -->
        <el-form-item v-if="form.type==='results' || form.type==='share'" :label="form.type==='results'?'后置':'分享后图片'" :label-width="formLabelWidth">
          <el-input v-if="form.type==='results'" v-model="form.after" autocomplete="off"></el-input>
          <!-- 转发分享 -->
          <el-upload v-if="form.type==='share'" class="upload-demo" :show-file-list="false" :http-request="afterUploadImg" :before-upload="beforeAvatarUpload">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <!--  -->
          <el-image v-if="form.type==='share'" class="up-image" :src="form.after">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" :style="{height:basis_src?'':'150px','line-height':basis_src?'':'150px'}" class="image-slot error">
              请上传图片...
            </div>
          </el-image>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reportDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitReportHandle">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 预览 -->
    <preview-mobile class="vv" :html="pp" :isPreview="preview"></preview-mobile>
    <!-- 隐藏这个公共组件 -->
    <div v-show="false">
      <report-preview ref="preview_html"></report-preview>
    </div>
  </div>
</template>
<script>
import {
  reportList,
  getTypeList,
  reportConfig,
  delRport,
  formulaList,
  upload_image
} from "@/api/measurement";
import {
  deepCopy
} from '@u/tools'
import previewMobile from '@c/preview-mobile'
import reportPreview from './child/report_preview'
export default {
  data() {
      return {
        list: [],
        pages: {},
        //
        formLabelWidth: '120px',
        form: {
          type: ''
        },
        reportDialog: false,
        content_list: [],
        //
        dynamic_result_type: [],
        formula_list: [],
        dynamic_text_list: [],
        result_index: null,
        preview: false,
        preview_text: '预览报告',
        pp: ''
      }
    },
    components: {
      previewMobile,
      reportPreview
    },
    methods: {
      // 预览
      previewHandle() {
this.$router.push({
          path: '/main/report_preview',
          query: {
            id: this.$route.query.id
          }
        });

        // this.preview = !this.preview;
        // this.preview_text = this.preview ? '收起报告' : '预览报告';

        // setTimeout(() => {
        //   this.pp = this.$refs.preview_html.$el.outerHTML;
        // }, 500)
      },
      toReportAllList() {
        this.$router.push({
          path: '/main/report_all_list',
          query: {
            id: this.$route.query.id
          }
        });
      },
      resultTypeChange(val) {
        if (this.result_index != val && this.form["content"]) {
          this.form["content"] = '';
          this.result_index = val;
        } else {
          this.result_index = null;
        }
        this.dynamic_result_type = val == 0 ? this.formula_list : this.dynamic_text_list;
      },
      beforeAvatarUpload(file) {
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 1;

        if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif') {
          isJPG = false;
          this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isJPG && isLt2M;
      },
      beforeUploadImg(param) {
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", param.file);
        //
        form.append("key", this.$route.path + '/before');
        form.append("preserve", 1);

        // 上传图片接口
        upload_image(form).then((data) => {
          this.$forceUpdate();
          this.form['before'] = data.image_url;
        });
      },
      afterUploadImg(param) {
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", param.file);
        //
        form.append("key", this.$route.path + '/after');
        form.append("preserve", 1);

        // 上传图片接口
        upload_image(form).then((data) => {
          this.$forceUpdate();
          this.form['after'] = data.image_url;
        });
      },
      typeToText(type) {
        return type === 'title1' ? '一级标题' :
          type === 'title2' ? '二级标题' :
          type === 'title3' ? '三级标题' :
          type === 'text' ? '动态文字' :
          type === 'chart' ? '动态图表' :
          type === 'image' ? '动态图片' :
          type === 'posters' ? '动态海报' :
          type === 'explain' ? '测评说明' :
          type === 'results' ? '测评结果' :
          type === 'share' ? '转发分享' : '无';
      },
      addReporthandle() {
        this.form = {};
        this.reportDialog = true;
      },
      // 修改
      editReporthandle(index, row) {

        this.form = deepCopy(row);
        if (this.form.type === 'results') {
          this.dynamic_result_type = this.form.result_type == 0 ? this.formula_list : this.dynamic_text_list;
          this.reportDialog = true;
          return
        }
        this.typeChange().then(() => {
          for (let key in this.content_list) {
            if (this.content_list[key].id == row.content && row.type != 'title1' && row.type != 'title2' && row.type != 'title3') {
              this.form['content'] = this.content_list[key].id;
              break;
            }
          }
          this.reportDialog = true;
        });

      },
      //
      submitReportHandle() {
        this.reportDialog = false;

        if (this.form.type === 'share' && !this.form['content']) {
          this.form['content'] = '';
        }

        this.form['eid'] = this.$route.query.id;
        this.form['sort'] = this.form.id ? this.form.sort : this.list.length + 1
        if (this.form.type !== 'results' && this.form.type !== 'share') {
          Vue.delete(this.form, 'result_type');
          Vue.delete(this.form, 'before');
          Vue.delete(this.form, 'after');
        }
        reportConfig(this.form).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return true
          }

          this.$notify({
            title: '成功',
            message: '添加成功',
            type: 'success'
          });
          this.pullData();
        });
      },
      //
      typeChange(val) {
        if (this.result_index != val && this.form["content"]) {
          this.form["content"] = '';
          this.result_index = val;
        } else {
          this.result_index = null;
        }
        if (this.form.type === 'results') {
          return
        }
        return getTypeList({
          eid: this.$route.query.id,
          type: this.form.type
        }).then((data) => {
          this.content_list = data.list;
        });
      },
      removeHandle(index, row) {
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (row.id) {
            delRport({
              id: row.id
            }).then((data) => {
              this.$notify({
                title: '成功',
                message: '添加成功',
                type: 'success'
              });
            });
          }
          this.list.splice(index, 1);
        }).catch();
      },
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      pullData() {
        this.$showLoading();
        let arr = formulaList({
          eid: this.$route.query.id
        });
        let arr2 = reportList({
          eid: this.$route.query.id,
          page: this.pages ? this.pages.page : null, //页码，默认1
          size: this.pages ? this.pages.size : null //每页数量，默认25
        })

        Promise.all([arr, arr2]).then((data) => {
          this.formula_list = data[0].list;
          this.pages = data[1].pager;
          this.list = data[1].list;
          this.$hideLoading();
        }).catch(() => {
          this.$hideLoading();
        });

        getTypeList({
          eid: this.$route.query.id,
          type: 'text'
        }).then((data) => {
          this.dynamic_text_list = data.list;
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.main {
  position: relative;
}

.addBtn {
  position: absolute;
  left: 0;
  bottom: 0;
}

.addBtn.previewBtn {
  left: 30px;
}

.addBtn.previewBtn.sortBtn {
  left: 135px;
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.up-image {
  margin: 20px auto auto;
  width: 187.5px;
  text-align: center;
  border-radius: 8px;
  .error {
    border-radius: 8px;
    background-color: rgba($color: #eeeeee, $alpha: .5);
  }
}
</style>
<style lang="scss">
.form-box {
  input,
  textarea {
    background-color: #fff !important;
    color: #333 !important;
    min-width: 300px;
  }
  .results-select .el-form-item__content {
    display: flex;
    .select {
      width: 49%;
      display: block;
      input {
        min-width: auto;
      }
    }
    .select.on {
      margin-left: auto;
    }
  }
}

.vv .content {
  font-size: 14px;
  background: none;
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 0;
  margin: 0;
}
</style>
